import * as ErrorMessages from './Components/ErrorMessages'

export const required = (text) => {
  if (text.toString().trim()) {
    return null
  }
  return ErrorMessages.isRequired
}

export const isEmail = (text) => {
  if (/^[^@]+@[^\.]+\..+$/.test(text)) {
    return null
  }
  return ErrorMessages.isEmail
}

export const isLimitedLength = (text) => {
  if (text.length < 255) {
    return null
  }
  return ErrorMessages.isLimitedLength
}

export const isLimitedInteger = (text) => {
  if (Number(text) <= Number.MAX_SAFE_INTEGER) {
    return null
  }
  return ErrorMessages.isLimitedInteger
}

export const isAlphanumeric = (text) => {
  if (/^[-A-Za-z0-9 ]+$/i.test(text)) {
    return null
  }
  return ErrorMessages.isAlphanumeric
}

export const isNumeric = (text) => {
  if (/^[0-9,.]+$/i.test(text)) {
    return null
  }
  return ErrorMessages.isNumeric
}

export const isPhoneNumber = (text) => {
  if (/^[0-9 \-+]+$/i.test(text)) {
    return null
  }
  return ErrorMessages.isPhoneNumber
}

export const onlyLatinSymbols = (text) => {
  if (/^[A-z0-9 ?!,.'’\-:;()\/&%$*#@<>=]*$/.test(text)) {
    return null
  }
  return ErrorMessages.onlyLatinSymbols
}

export const onlyLatinSymbolsWithNewLine = (text) => {
  if (/^[A-z0-9 ?!,.'’\-:;()\/&%$*#@<>=]*$/gm.test(text)) {
    return null
  }
  return ErrorMessages.onlyLatinSymbols
}

export const minLength = (length) => {
  return (text) => {
    return text.trim().length >= length ? null : ErrorMessages.minLength(length)
  }
}

export const maxLength = (length) => {
  return (text) => {
    return text.length <= length ? null : ErrorMessages.maxLength(length)
  }
}

export const min = (length) => {
  return (text) => {
    return text >= length ? null : ErrorMessages.min(length)
  }
}

export const max = (length) => {
  return (text) => {
    return text <= length ? null : ErrorMessages.max(length)
  }
}

export const notLowerThan50Percent = (originalPrice) => {
  return (input) => {
    return input >= originalPrice * 0.5 ? null : ErrorMessages.notLowerThan50Percent
  }
}

export const isUsername = (text) => {
  if (/^[-A-Za-z0-9]*$/.test(text)) {
    return null
  }
  return ErrorMessages.isUsername
}

export const validateCompetitors = (text) => {
  let competitorNotMentioned = true
  const downcasedInputValue = text.toLowerCase()
  const competitorsList = [
    'turbosquid', 'sketchfab', 'skfb.ly', 'gumroad', 'grabcad.com', 'shapeways.com', '3docean.net',
    '3dexport.com', 'pinshape.com', 'daz3d.com', 'assetstore.unity3d.com', 'renderosity.com',
    'free3d.com', 'cults3d.com', '3dsky.org', 'highend3d.com',
  ]

  competitorsList.map((competitor) => {
    if (downcasedInputValue.includes(competitor)) {
      competitorNotMentioned = false
    }
  })

  if (competitorNotMentioned) {
    return null
  }
  return ErrorMessages.validateCompetitors
}

export const minArrLength = (length) => {
  return (arr) => {
    return arr.length < length ? ErrorMessages.minArrLength(length) : null
  }
}

export const maxArrLength = (length) => {
  return (arr) => {
    return arr.length > length ? ErrorMessages.maxArrLength(length) : null
  }
}

export const decimalPrice = (value) => {
  return String(value).match(/^\d+[\.,]?\d{0,2}$/) ? null : ErrorMessages.decimalPrice
}

export const tagsRegexp = /^[A-Za-z0-9]{1}[-A-Za-z0-9]*([ ]{1}[A-Za-z0-9]{1}[-A-Za-z0-9]*)*$/

export const noEmoji = (value) => {
  const re = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g

  return re.test(value) ? ErrorMessages.noEmoji : null
}
